module.exports = __webpack_public_path__ + "static/media/gal1.08dea132.jpg";